/**
 * Path Configuration section of case defaults.
 *
 * Extracted from AdminSettingsPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'
import type { OrgCaseDefaults, UpdateOrgCaseDefaultsRequest } from '../../types/case-container'
import { DefaultsField } from './DefaultsField'

interface PathConfigSectionProps {
  orgDefaults: OrgCaseDefaults | null
  formData: UpdateOrgCaseDefaultsRequest
  setFormData: (data: UpdateOrgCaseDefaultsRequest) => void
  editMode: boolean
}

export function PathConfigSection({
  orgDefaults,
  formData,
  setFormData,
  editMode,
}: PathConfigSectionProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div className="space-y-3 border-t border-stone-200 pt-4 dark:border-stone-700">
      <h4 className="text-sm font-medium text-stone-700 dark:text-stone-300">
        {t('adminSettings.pathConfiguration')}
      </h4>
      <div className="grid gap-4 sm:grid-cols-2">
        <DefaultsField
          label={t('adminSettings.velociraptorExportPath')}
          value={orgDefaults?.velociraptorExportPath}
          editValue={formData.velociraptorExportPath ?? ''}
          editMode={editMode}
          onChange={(v) => {
            setFormData({ ...formData, velociraptorExportPath: v || null })
          }}
        />
        <DefaultsField
          label={t('adminSettings.evidenceImportPath')}
          value={orgDefaults?.evidenceImportPath}
          editValue={formData.evidenceImportPath ?? ''}
          editMode={editMode}
          onChange={(v) => {
            setFormData({ ...formData, evidenceImportPath: v || null })
          }}
        />
        <DefaultsField
          label={t('adminSettings.reportExportPath')}
          value={orgDefaults?.exportPath}
          editValue={formData.exportPath ?? ''}
          editMode={editMode}
          onChange={(v) => {
            setFormData({ ...formData, exportPath: v || null })
          }}
        />
      </div>
    </div>
  )
}
